import {Component} from '@angular/core';
import {RedirectCommand, Router} from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  imports: [],
  template: `<div class="content-pane"
    ><h2>Page Not Found</h2><p><b>We're sorry, the page you requested was not found.</b></p
    ><p
      >If you believe that you are seeing this in error, please
      <a href="mailto:rde_admin@rdexchange.org">contact support</a> for assistance.</p
    ></div
  >`,
})
export class PageNotFoundComponent {}

export const redirectTo404 = (router: Router, response: ResponseInit) => {
  if (response) {
    response.status = 404;
    response.statusText = 'Not Found';
  }
  return new RedirectCommand(router.parseUrl('/404'), {browserUrl: router.getCurrentNavigation().initialUrl});
};
